import {
  SHOP_PRODUCTS_REQUEST,
  SHOP_PRODUCTS_SUCCESS,
  // SHOP_PRODUCTS_FAILURE,
  SHOP_PRODUCTS_CLEAR,
} from 'app/common/actions/shop/catalog/products';


const defaultState = {
  data: [],
  loading: false,
};

const products = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_PRODUCTS_REQUEST: {
      return { ...state, loading: true };
    }

    case SHOP_PRODUCTS_SUCCESS: {
      return { ...state, loading: false, data: payload };
    }

    case SHOP_PRODUCTS_CLEAR: {
      return defaultState;
    }

    default:
  }
  return state;
};

export default products;
